import { useAuthUser } from '@frontegg/react';
import { Permission } from '@common/utils/admin_permissions';
import { useMemo } from 'react';

export function useHasPermission(permissions: Permission[]) {
  const user = useAuthUser();

  return useMemo(() => {
    if (!user) return false;

    // Check if user has ALL of the required permissions
    return permissions.every((perm) => user.permissions.some((p) => p.key === perm));
  }, [user, permissions]);
}
